/* eslint-disable comma-dangle */
/* eslint-disable indent */
/* eslint-disable quotes */
// Common
import "./lib/common/common.js";

// Load Web components
import "../components/kw-button-languages/kw-button-languages.js";
import "../components/kw-footer/kw-footer.js";
import "../components/kw-header/kw-header.js";
import "../components/kw-card-item/kw-card-item";
import "../components/kw-wrapper-cards/kw-wrapper-cards";
import "../components/kw-title/kw-title.js";
import "../components/kw-tab-list/kw-tab-list.js";
import "../components/kw-banner/kw-banner.js";
import "../components/kw-carousel/kw-carousel.js";

// Load scroll behavior to show/hide header
import "./lib/scroll/scroll.js";
import { CommonTpl } from "./pages/common.html.mjs";
import DataLanguage from "./lib/data-language.js";
import dataBanner from "./lib/dataBanner.js";
import dataBanners from "../json/internshipBannerData.json";
import data from "../json/agile.json";

CommonTpl.setData(data);
CommonTpl.detectLanguage();
const { lang } = document.querySelector("html");

function banner() {
  const bannerData = document.getElementById("banner-internship");
  bannerData.innerHTML = `
    <kw-banner id="Banner" banner-size="internship" animation-type="slide-toleft" change-interval="8" class="internship__kw-banner-clip-path">
      ${DataLanguage.dataLanguage(dataBanners.internshipBannerData, lang)
        .map(dataBanner.banner)
        .join("")}
    </kw-banner>
`;
}
function handleLoadWindowFunctions() {
  banner();
}

if (document.addEventListener) {
  window.addEventListener("load", handleLoadWindowFunctions);
}
